import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';

import PopoverTrigger from '../../components/PopoverTrigger';
import AdvancedAccountFilteringPopover from './AdvancedAccountFilteringPopover';
import { getUserOrganizationPreference } from '../../helpers/user-preferences';

export default function AdvancedAccountFilteringContainer(props) {
  const {
    organization_id, setLocalFilterOptions
  } = props;

  const [accountSummaryFilterValue, setAccountSummaryFilterValue] = useState(0);
  const [accountOldFilerValue, setAccountOldFilterValue] = useState(0);
  const [accountIgnoreFilterValue, setAccountIgnoreFilterValue] = useState(0)
  const [accountEmptyFilter, setAccountEmptyFilterValue] = useState(0)
  const [advancedFilterCount, setAdvancedFilterCount] = useState(0)

  useEffect(() => {
    let local_filter_options = { 'accountSummaryFilterValue': 0, 'accountOldFilerValue': 0, 'accountIgnoreFilterValue': 0, 'accountEmptyFilter': 0 }

    local_filter_options['accountSummaryFilterValue'] = accountSummaryFilterValue
    local_filter_options['accountOldFilerValue'] = accountOldFilerValue
    local_filter_options['accountIgnoreFilterValue'] = accountIgnoreFilterValue
    local_filter_options['accountEmptyFilter'] = accountEmptyFilter

    setLocalFilterOptions(local_filter_options);
  }, [accountSummaryFilterValue, accountOldFilerValue, accountIgnoreFilterValue, accountEmptyFilter, setLocalFilterOptions])


  useEffect(() => {
    let filter_count = 0
    if (accountSummaryFilterValue > 0) {
      filter_count += 1
    }
    if (accountOldFilerValue > 0) {
      filter_count += 1
    }
    if (accountIgnoreFilterValue > 0) {
      filter_count += 1
    }
    if (accountEmptyFilter > 0) {
      filter_count += 1
    }
    setAdvancedFilterCount(filter_count)
  }, [accountSummaryFilterValue, accountOldFilerValue, accountIgnoreFilterValue, accountEmptyFilter])


  useEffect(() => {
    setAccountSummaryFilterValue(getUserOrganizationPreference('asf', organization_id))
    setAccountOldFilterValue(getUserOrganizationPreference('aof', organization_id))
    setAccountIgnoreFilterValue(getUserOrganizationPreference('aif', organization_id))
    setAccountEmptyFilterValue(getUserOrganizationPreference('aef', organization_id))
  }, [organization_id])

  return (
    <div style={{ position: 'relative' }}>
      <PopoverTrigger
        rootClose={true}
        popoverTitle={'Advanced Filtering Options'}
        popoverContent={
          <AdvancedAccountFilteringPopover
            organization_id={organization_id}
            setAccountSummaryFilterValue={setAccountSummaryFilterValue}
            setAccountOldFilterValue={setAccountOldFilterValue}
            setAccountIgnoreFilterValue={setAccountIgnoreFilterValue}
            setAccountEmptyFilterValue={setAccountEmptyFilterValue}
          />
        }
        trigger='click'
        placement='right'
      >
        <div>
          <FontAwesomeIcon
            style={{
              fontSize: '30px',
              color: 'var(--et_tab_grey)',
              cursor: 'pointer',
              position: 'relative',
              top: '20px',
              right: '5px',
            }}
            icon={faFilter}
            id={'report-date-popover'}
          />
          {advancedFilterCount > 0 && <div style={{
            position: 'relative', top: '-10px',
            right: '-7px', 'color': 'white', fontSize: '12px', cursor: 'pointer',
          }}>
            {advancedFilterCount}
          </div>}
        </div>
      </PopoverTrigger>
    </div>)
}